module.exports = __webpack_public_path__ + "images/dingtalk/init-project-7122a837c05bcb67512ba5ddb6271148.png";